import { createMutation } from "@/mutations";
import { requestPasswordReset } from "@/features/auth/api/password";
import type { AxiosResponse } from "axios";

type ForgotPasswordResponse = Awaited<
  ReturnType<typeof requestPasswordReset>
> extends AxiosResponse<infer T>
  ? T
  : never;

export const useForgotPasswordMutation = () => {
  return createMutation<ForgotPasswordResponse, string>({
    mutationFn: async (email) => {
      const response = await requestPasswordReset(email);
      return response.data;
    },
  });
};

